import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { LettersApi } from '@shared/api';

interface UseArchiveLetterStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  archiveLetter: (id: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useArchiveLetterStore = create<UseArchiveLetterStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  archiveLetter: async (id, signal) => {
    try {
      set({ loading: true, data: false, error: null });
      await LettersApi.archiveLetter(id, signal);
      set({ data: true, loading: false });
    } catch (error) {
      set({ loading: false, data: false, error: ApiUtils.getApiError(error) });
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
